/**
 * @generated SignedSource<<017ac4d850b6a843b43771e2ddee8391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTeamInput = {
  description?: string | null | undefined;
  generationDescription?: string | null | undefined;
  name: string;
};
export type TeamSelectionModalCreateTeamMutation$variables = {
  input: CreateTeamInput;
};
export type TeamSelectionModalCreateTeamMutation$data = {
  readonly createTeam: {
    readonly team: {
      readonly id: any;
      readonly name: string;
    };
  };
};
export type TeamSelectionModalCreateTeamMutation = {
  response: TeamSelectionModalCreateTeamMutation$data;
  variables: TeamSelectionModalCreateTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTeamPayload",
    "kind": "LinkedField",
    "name": "createTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLTeam",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSelectionModalCreateTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamSelectionModalCreateTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27cc092476c77505aee4ea30f95ec5df",
    "id": null,
    "metadata": {},
    "name": "TeamSelectionModalCreateTeamMutation",
    "operationKind": "mutation",
    "text": "mutation TeamSelectionModalCreateTeamMutation(\n  $input: CreateTeamInput!\n) {\n  createTeam(input: $input) {\n    team {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da40389c202fcaffffa496b25b93cbfe";

export default node;
